<template>
  <div id="course" class="app-inner">
       <div class="public-btn-div flex align-cen"  v-if="!selectType">
      <div class="public-add"  @click="addStInfo">
        新增学员
      </div>
    </div>
      <div class="p-tit-c">
        <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">学员姓名：</div>
          <div class="el-select1">
            <el-input placeholder="请输入学员姓名" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">学员电话：</div>
          <div class="el-select1">
          <el-input placeholder="请输入学员电话" v-model="search1" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
          <div class="label">学员身份证：</div>
          <div class="el-select1">
          <el-input placeholder="请输入学员身份证" v-model="search2" clearable> </el-input>
          </div>
         </div>
      </div>
                 <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件 
        </div>
      </div>
        </div>
      </div>
                <div class="businessList-container">
        <div class="businessList-container-table">
             <el-table
             ref="multipleTable"
            :data="list"
            border
            style="width: 100%"
            id='mytable'
            :key="23144"
          :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          @select='onTableSelect'
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column type="selection" width="55" reserve-selection v-if="selectType"> 
         </el-table-column>
            <el-table-column
            prop="name"
            label="姓名"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="phone"
            label="电话"
           align="center"
            >
            </el-table-column>
           <el-table-column
            prop="idNo"
            label="身份证号"
           align="center"
            >
            </el-table-column>
        <el-table-column label="学员照片" align="center" prop="pic">
            <template slot-scope="scope" >
                <img :src="scope.row.pic" alt="" style="display: block;width:30%;margin:0 auto">
            </template>
         </el-table-column>
          <el-table-column label="领取证书" align="center" v-if="!selectType">
            <template slot-scope="scope" >
                <div style="color:red;cursor: pointer;" @click="openReceive(scope.row)">{{scope.row.certNum}}</div>
            </template>
         </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            v-if="!selectType"
            >
              <template slot-scope="scope">
                <div>
                    <el-button type="text" size="small" @click="addStInfo(scope.row)">编辑</el-button>
                <el-button type="text" size="small"  class="daner" style="color:red" @click="deletSt(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
        </el-table>
         <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
      </div>
           <el-dialog
          title="领取证书"
          :visible.sync="centerDialogVisible"
          width="50%"
          :append-to-body="true"
          center>
           <div class="businessList-container-table">
                   <el-table
                    ref="multipleTable2"
                    :data="list1"
                    tooltip-effect="dark"
                    style="width: 100%"
                    border
                    :key="212"
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"

                  >
                   <el-table-column prop="certName" label="证书名称" align="center" >
                    </el-table-column>
                     <el-table-column prop="certificateNo" label="证书ID" align="center" width="200">
                    </el-table-column>
                     <el-table-column prop="classifyName" label="证书类型" align="center" width="200">
                    </el-table-column>
                     <el-table-column
                      label="操作"
                      align="center"
                      width="200"
                      >
                      <template slot-scope="scope">
                        <div>
                            <el-button type="text" size="small" style="color:red" @click="uploadCert(scope.row)">查看证书</el-button>
                        <el-button type="text" size="small"  class="daner" style="color:red" @click="deletSt1(scope.row)">取消关联</el-button>
                        </div>
                      </template>
            </el-table-column>
                   </el-table>
           </div>
           </el-dialog>
  </div>
</template>
<script>
import {getcertRecipient,getcertReceive,deletCert,getReceive} from "@/api/index/index"  //证书学员分页、领取证书分页、删除证书
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    components:{
      paginaTion
    },
    props: {
    selectType: [String, Boolean], //是否为组件调用 
    },
  data () {
    return {
      selsctarr:[],
      multipleSelection:[],
      catchStatus:false,
      centerDialogVisible:false,
      search:'',
      search1:'',
      search2:'',
      list:[],
      currentPage: 1, //初始页
      PageSize: 10, //每页的数据
      totalCount: 0,
      list1:[],
      currentPage1: 1, //初始页
      PageSize1: 10, //每页的数据
      totalCount1: 0,
    }
  },
  activated(){
        this.getList()
    },
  created () {
   
    if(this.selectType) this.getList()
  },
  methods: {
       // 取消关联
    deletSt1(data){
       this.$confirm('确定要取消关联该学员？取消关联后，该学员的证书将不展示。', '温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  getReceive({id:data.id},'DELETE')
                  .then(res =>{
                    if(res.code == 0){
                      this.$util.Notifi('取消成功','success','fa-check')
                      this.centerDialogVisible =
                   this.getList()
                    }else{
                      this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                  })
              }).catch(() => {          
              });
    },
    uploadCert(data){
         const newurl = this.$router.resolve({name: 'enCert', query: {certId: data.id}})
        window.open(newurl.href,'_blank')
    },
        emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
    // 获取证书学院列表
    getList(){
      let params = {
        name:this.search,
        id:this.search2,
        phone:this.search1,
        current: this.currentPage,
        size:this.PageSize,
      }
      getcertRecipient(params)
      .then(res =>{
          this.list = res.data.records
          this.totalCount = res.data.total;
          if(this.selectType){
          let rows = []
              for (let m = 0; m < this.selsctarr.length; m++) {
            for (let n = 0; n < this.list.length; n++) {
            if (this.selsctarr[m].idNo === this.list[n].idNo) {
                rows.push(this.list[n])
            }
            }
        }
            rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row,true)
        })
 
             }
      })
    },
    // 搜索
    classSelect(){
      this.currentPage = 1
     this.getList()
    },
    // 重置
    reset(){
       this.search=""
          this.search1=""
           this.search2=""
          this.currentPage=1
          this.getList()
    },
    // 新增学员
    addStInfo(data){
      this.$router.push({
        name: "addCertSt",
        query:{
            id:data.id,
        }
        })
    },
    // 删除学员
    deletSt(data){
       this.$confirm('确定要删除该学员信息？删除后该学员所获得的证书就会被清空。', '温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  deletCert({id:data.id},'DELETE')
                  .then(res =>{
                    if(res.code == 0){
                      this.$util.Notifi('删除成功','success','fa-check')
                   this.getList()
                    }else{
                      this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                  })
              }).catch(() => {          
              });
    },
    // 打开领取证书窗口
    openReceive(data){
      this.centerDialogVisible = true
      this.getList1(data.id)
    },
    // 获取学员领取证书
    getList1(id){
       let params = {
        recipientId:id,
        current: this.currentPage1,
        size:this.PageSize1,
      }
      getcertReceive(params)
      .then(res =>{
          this.list1 = res.data.records
          this.totalCount1 = res.data.total;
      })
    },
             // 表格选择
         handleSelectionChange(val) {
            if(this.catchStatus){
            this.multipleSelection = val;
             this.multipleSelection = this.multipleSelection.filter(item => item.id); //去重，防止同一条数据出现两次
            }else{
                  this.multipleSelection = val;
            } 
           this.$emit('sendStatus1', this.multipleSelection,false)
         },
                // 新增修改调用方法
        editfun(val){
            this.selsctarr = val        
        },
        // 新增修改调用清空方法
        remove(){
           this.multipleSelection = []
        },
              // 手动选择
    onTableSelect(rows, row){
         this.catchStatus = rows.length && rows.indexOf(row) !== -1
    },
         getRowKeyOfTarget(row) {
            return row.id
            },
  },
}
</script>
<style lang="scss" scoped>

</style>